import React from 'react';
import { Link } from 'react-router-dom';
import { Search, Menu, User } from 'lucide-react';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col font-body bg-background text-foreground">
      {/* Glassmorphism Header */}
      <header className="fixed top-0 left-0 right-0 z-50 h-20 px-6 md:px-12 flex items-center justify-between bg-white/70 backdrop-blur-xl border-b border-white/20 transition-all duration-300">
        <div className="flex items-center gap-12">
          <Link to="/" className="text-2xl font-heading font-bold tracking-tight">
            MALDIVES<span className="text-accent">.AI</span>
          </Link>
          <nav className="hidden md:flex gap-8 text-sm font-medium tracking-wide uppercase">
            <Link to="/search" className="hover:text-primary/70 transition-colors">Resorts</Link>
            <Link to="/collections" className="hover:text-primary/70 transition-colors">Collections</Link>
            <Link to="/about" className="hover:text-primary/70 transition-colors">Our Story</Link>
          </nav>
        </div>
        
        <div className="flex items-center gap-6">
          <button className="hidden md:flex items-center gap-2 text-sm font-medium hover:text-primary/70">
            <User size={18} />
            SIGN IN
          </button>
          <button className="md:hidden">
            <Menu size={24} />
          </button>
          <Link to="/search">
             <button className="bg-primary text-white rounded-full px-6 py-2.5 text-xs font-bold tracking-widest hover:bg-primary/90 transition-all shadow-lg">
              BOOK NOW
            </button>
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-grow pt-20">
        {children}
      </main>

      {/* Footer */}
      <footer className="bg-primary text-white py-24 px-6 md:px-12">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="space-y-6">
            <h3 className="text-3xl font-heading font-bold">MALDIVES.AI</h3>
            <p className="text-white/60 font-light leading-relaxed">
              Curating the world's most exclusive island escapes using advanced intelligence.
            </p>
          </div>
          
          <div>
            <h4 className="font-heading text-lg mb-6 text-accent">Explore</h4>
            <ul className="space-y-4 text-white/60 font-light">
              <li><a href="#" className="hover:text-white transition-colors">All Resorts</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Overwater Villas</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Family Suites</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Experiences</a></li>
            </ul>
          </div>

          <div>
             <h4 className="font-heading text-lg mb-6 text-accent">Company</h4>
             <ul className="space-y-4 text-white/60 font-light">
               <li><a href="#" className="hover:text-white transition-colors">About Us</a></li>
               <li><a href="#" className="hover:text-white transition-colors">Concierge</a></li>
               <li><a href="#" className="hover:text-white transition-colors">Journal</a></li>
               <li><a href="#" className="hover:text-white transition-colors">Contact</a></li>
             </ul>
           </div>
           
           <div>
             <h4 className="font-heading text-lg mb-6 text-accent">Newsletter</h4>
             <p className="text-white/60 mb-6 font-light">Get the latest luxury drops.</p>
             <div className="flex border-b border-white/20 pb-2">
               <input 
                 type="email" 
                 placeholder="Email Address" 
                 className="bg-transparent border-none outline-none text-white placeholder:text-white/30 w-full"
               />
               <button className="text-accent uppercase text-xs font-bold tracking-widest">Join</button>
             </div>
           </div>
        </div>
        <div className="max-w-7xl mx-auto mt-24 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between text-white/40 text-xs">
          <p>© 2025 Maldives AI. All rights reserved.</p>
          <div className="flex gap-6 mt-4 md:mt-0">
            <a href="#">Privacy</a>
            <a href="#">Terms</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
